module.exports = __webpack_public_path__ + "static/media/primary-information.db702b04.svg";